var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('nav-bar',{attrs:{"user":_vm.currentUser}}),_c('v-main',{staticClass:"scroll-container"},[_c('router-view',{attrs:{"user":_vm.currentUser}})],1),(_vm.showFooter())?_c('footer-comp',{staticClass:"footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }